/* ============================================================
   POSTERARTE · posterarte.b2b.js
   B2B Registration Form — /pages/mayoristas
   AJAX submission to api.posterarte.com/b2b
   Vanilla JS — no jQuery, no hardcoded strings
   ============================================================ */

(function () {
  'use strict';

  var page = document.querySelector('.b2b-page');
  if (!page) return;

  var formCol = page.querySelector('.b2b-form-col');
  var form    = page.querySelector('.b2b-form');
  var submit  = page.querySelector('.b2b-submit');
  var apiUrl  = (page.dataset.api || '').trim();

  if (!form || !submit || !formCol) return;

  /* ----------------------------------------------------------
     Card selection (single-select radiogroup)
  ---------------------------------------------------------- */
  var cardGroup = form.querySelector('.b2b-cards');
  var cardValue = null;

  if (cardGroup) {
    cardGroup.querySelectorAll('.b2b-card').forEach(function (card) {
      card.addEventListener('click', function () {
        cardGroup.querySelectorAll('.b2b-card').forEach(function (c) {
          c.classList.remove('selected');
          c.setAttribute('aria-checked', 'false');
        });
        card.classList.add('selected');
        card.setAttribute('aria-checked', 'true');
        cardValue = card.dataset.value;
        var block = card.closest('.b2b-field-block');
        if (block) block.classList.remove('has-error');
      });
    });
  }

  /* ----------------------------------------------------------
     Segmented volume selector (single-select radiogroup)
  ---------------------------------------------------------- */
  var segGroup = form.querySelector('.b2b-segmented');
  var segValue = null;

  if (segGroup) {
    segGroup.querySelectorAll('.b2b-seg').forEach(function (seg) {
      seg.addEventListener('click', function () {
        segGroup.querySelectorAll('.b2b-seg').forEach(function (s) {
          s.classList.remove('selected');
          s.setAttribute('aria-checked', 'false');
        });
        seg.classList.add('selected');
        seg.setAttribute('aria-checked', 'true');
        segValue = seg.dataset.value;
        var block = seg.closest('.b2b-field-block');
        if (block) block.classList.remove('has-error');
      });
    });
  }

  /* ----------------------------------------------------------
     Clear field error on input
  ---------------------------------------------------------- */
  form.querySelectorAll('.b2b-field[data-required] input').forEach(function (inp) {
    inp.addEventListener('input', function () {
      var field = inp.closest('.b2b-field');
      if (field) field.classList.remove('has-error');
    });
  });

  /* ----------------------------------------------------------
     Validation
  ---------------------------------------------------------- */
  function validate() {
    var ok = true;

    // Required text / email fields
    form.querySelectorAll('.b2b-field[data-required]').forEach(function (field) {
      var inp   = field.querySelector('input');
      if (!inp) return;
      var valid = inp.value.trim() !== '';
      if (valid && inp.type === 'email') {
        valid = /^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(inp.value.trim());
      }
      field.classList.toggle('has-error', !valid);
      if (!valid) ok = false;
    });

    // Email match
    var emailInput   = form.querySelector('[name="email"]');
    var confirmInput = form.querySelector('[name="email_confirm"]');
    if (
      emailInput && confirmInput &&
      emailInput.value.trim() &&
      confirmInput.value.trim() &&
      emailInput.value.trim() !== confirmInput.value.trim()
    ) {
      var confirmField = confirmInput.closest('.b2b-field');
      if (confirmField) confirmField.classList.add('has-error');
      ok = false;
    }

    // Business-type card required
    if (cardGroup) {
      var cardBlock = cardGroup.closest('.b2b-field-block');
      if (cardBlock) cardBlock.classList.toggle('has-error', !cardValue);
      if (!cardValue) ok = false;
    }

    // Volume segment required
    if (segGroup) {
      var segBlock = segGroup.closest('.b2b-field-block');
      if (segBlock) segBlock.classList.toggle('has-error', !segValue);
      if (!segValue) ok = false;
    }

    return ok;
  }

  /* ----------------------------------------------------------
     Show thank-you state and scroll form column into view
  ---------------------------------------------------------- */
  function showThanks() {
    formCol.classList.add('is-done');
    formCol.scrollIntoView({ behavior: 'smooth', block: 'start' });
  }

  /* ----------------------------------------------------------
     Form submit
  ---------------------------------------------------------- */
  form.addEventListener('submit', function (e) {
    // Solo se para el envio si la validacion falla: si pasa, el clic ENVIA el formulario nativo y el antibots
    // de Shopify actua sobre ese envio (2026-10-09; ver posterarte-b2b.liquid).
    if (!validate()) { e.preventDefault(); return; }

    var submitText  = submit.dataset.submitText  || submit.textContent.trim();
    var loadingText = submit.dataset.loadingText || '…';
    var errorEl     = form.querySelector('.b2b-submit-error');

    // Hide previous error
    if (errorEl) errorEl.style.display = 'none';

    // Loading state
    submit.classList.add('loading');
    submit.textContent = loadingText;
    submit.disabled    = true;

    // Build payload — field names match the Worker's expected schema
    // never send email_confirm
    var ccEl       = form.querySelector('[name="cc"]');
    var telefonoEl = form.querySelector('[name="telefono"]');
    var origenEl   = form.querySelector('[name="origen"]');
    var mensajeEl  = form.querySelector('[name="mensaje"]');
    var webEl      = form.querySelector('[name="web"]');

    var payload = {
      email:          (form.querySelector('[name="email"]') || {}).value.trim(),
      first_name:     (form.querySelector('[name="nombre"]') || {}).value.trim(),
      last_name:      (form.querySelector('[name="apellidos"]') || {}).value.trim(),
      phone:          ((ccEl ? ccEl.value : '') + ' ' + (telefonoEl ? telefonoEl.value.trim() : '')).trim(),
      company_name:   (form.querySelector('[name="empresa"]') || {}).value.trim(),
      vat:            (form.querySelector('[name="cif"]') || {}).value.trim(),
      web_instagram:  webEl ? webEl.value.trim() : '',
      business_type:  cardValue,
      monthly_volume: segValue,
      source:         origenEl ? origenEl.value : '',
      message:        mensajeEl ? mensajeEl.value.trim() : '',
      submitted_at:   new Date().toISOString(),
      locale:         'es'
    };

    // ENVIO POR EL FORMULARIO NATIVO DE SHOPIFY (2026-10-09, lista de apertura A4). Antes: fetch al Worker de
    // api.posterarte.com/b2b, con el CORS fijado al dominio viejo -ningun lead llegaba- y, sin endpoint,
    // «gracias» SIN enviar nada. Ahora la solicitud entera va en contact[body] del formulario nativo
    // (#b2b-nativo, en posterarte-b2b.liquid), que llega al correo de la tienda. Un envio normal, no fetch:
    // asi pasa por la comprobacion antibots de Shopify si la pide. Al volver, la pagina pinta el «gracias».
    var nativo = form;   // el formulario visible ES el nativo de contacto de Shopify
    var etiquetas = {
      email: 'Email', first_name: 'Nombre', last_name: 'Apellidos', phone: 'Teléfono',
      company_name: 'Empresa', vat: 'CIF/NIF', web_instagram: 'Web o Instagram',
      business_type: 'Tipo de negocio', monthly_volume: 'Volumen mensual', source: 'Cómo nos conoció',
      message: 'Mensaje'
    };
    var cuerpo = ['SOLICITUD DE MAYORISTA · /pages/mayoristas', ''];
    Object.keys(etiquetas).forEach(function (k) {
      if (payload[k]) cuerpo.push(etiquetas[k] + ': ' + payload[k]);
    });
    nativo.querySelector('[name="contact[email]"]').value   = payload.email;
    nativo.querySelector('[name="contact[name]"]').value    = (payload.first_name + ' ' + payload.last_name).trim();
    nativo.querySelector('[name="contact[phone]"]').value   = payload.phone;
    nativo.querySelector('[name="contact[empresa]"]').value = payload.company_name;
    nativo.querySelector('[name="contact[body]"]').value    = cuerpo.join('\n');
    // Y nada mas: el envio sigue su curso. Lanzarlo desde codigo fallo dos veces el 2026-10-09 (submit():
    // «Missing CAPTCHA token»; requestSubmit() sobre un formulario oculto: colgado).
  });

  // Vuelta del envio nativo: Shopify recarga la pagina y el formulario marca el exito.
  if (document.querySelector('[data-b2b-enviado]')) showThanks();

})();
